exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mhd--color--circle {\n  width: 8px;\n  height: 8px;\n  margin-right: 5px;\n  border-radius: 50%;\n  display: inline-block; }\n\n.mhd--color-swatch {\n  padding: 5px;\n  margin: 5px 0;\n  cursor: pointer;\n  border-radius: 1px;\n  background: #eee;\n  display: inline-block;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1); }\n  .mhd--color-swatch--color {\n    width: 36px;\n    height: 14px;\n    border-radius: 2px; }\n    .mhd--color-swatch--color--text {\n      font-size: 11px;\n      margin-bottom: 10px; }\n  .mhd--color-swatch--popover {\n    z-index: 2;\n    position: absolute; }\n  .mhd--color-swatch--cover {\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    position: fixed; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Common/Form/colorPicker.scss
// module id = 1453
// module chunks = 1